var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72504 6.48398C8.46451 6.22597 8.04433 6.22691 7.78475 6.48649C6.87776 7.39348 4.9714 9.29984 4.9714 9.29984C4.71119 9.56005 4.71119 9.98243 4.9714 10.2426C5.23162 10.5029 5.654 10.5029 5.91421 10.2426L8.27124 7.88562L10.6283 10.2426C10.8885 10.5029 11.3109 10.5029 11.5711 10.2426C11.8313 9.98243 11.8313 9.56005 11.5711 9.29984C11.5711 9.29984 9.64082 7.38971 8.72504 6.48398Z",
    fill: "#E3E6F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.5fda9a8aa75d15ef31f8ae94c8dcf14a.svg";
export { ForwardRef as ReactComponent };